// extracted by mini-css-extract-plugin
export default {"butt":"exporttoexcel_butt__P5Nsf"};